module.exports = __webpack_public_path__ + "static/img/5f5d3be4ed1d8d352d2e5c0a5fdb3e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv8.jpg
// module id = WXEg
// module chunks = 1